import BaseComponent from "./BaseComponent";
import LayoutHelper from "../Helper/Layout";
import App from "../Core/App";

export default class BoxQuadratic extends BaseComponent {
    constructor() {
        super();

        //store the edited/unedited text
        this.buffer = [];

        this._onResize();
        //this._bindListener( 'click', this._onJumpClick, '.blb-box-jump > span.blb-box-jump-button' );
    }

    /** No longer needed, but nice code non the less
    _onJumpClick( e ) {
        e.preventDefault();
        let that = $(e.target),
            vs   = that.parents('.blb-box-quadratic-wrapper').find('.blb-textpic.lol').first(),
            sc   = vs.find('.blb-text'),
            data = sc.data(),
            dir  = that.hasClass('next') ? 1 : -1,
            nLoc = data.location + dir,
            lol  = sc.find('p.list-of-links > span.blb-link'),
            nextEl;

         // Prevent overscroll
        if(nLoc < 0 || nLoc > data.locationMax) return;
        // Are there any animations running?
        if( sc.data('animation-running') ) return;
        else sc.data('animation-running', true);


        if(dir === 1) {
            nextEl = $(lol[ data.viewspace + data.location ]);
            
        } else {
            nextEl = $(lol[ data.viewspace + data.location - 1 ]);
        }

        let height = nextEl.height();
        if( data.location === 0 && data.offset > 0 ) height = data.offset; // First click on 'next'

        sc.data( 'location', nLoc );

        // Bind event as animation running check
        sc.on('transitionend', () => { 
            $(sc).data('animation-running', false);
            $(sc).off('transitionend'); 
        });

        if( nLoc > 0 ) {
            sc.css( 'top', parseInt(sc.css('top')) + dir * -1 * height );
        } else {
            sc.css( 'top', 0 ); // Last click on 'prev'
        }
    }
     */

    /**
     * This piece of code allows the .box-quadratic elements @ landing page to
     * overflow. It turns them into a scrollable list.
    linkListToggle() {
        if( LayoutHelper.getCurrentLayout() == 'mobile' ) return;

        $('.blb-box-quadratic').each((i, el) => {
            if( $(el).find('p.list-of-links').length < 1 ) return;

            let wrap        = $(el).find('.blb-box-quadratic-wrapper').first(),
                viewspace   = wrap.find('.blb-textpic.lol').first(),
                container   = viewspace.find('.blb-text').first();

            // Is our container already flaged? if so, we have to check another
            if( wrap.hasClass('hasOverflow') ) {
                // There is no overflow any longer, we can revert back to normal and exit
                if( !LayoutHelper.overflows( container, wrap, true, {x:0,y:2} ) ) {
                    wrap.removeClass('hasOverflow');
                    return;
                }
            } else {
                // First run and no overflow, we can just exit
                if( !LayoutHelper.overflows( container, viewspace, true, {x:0,y:2} ) ) return;
            }

            wrap.addClass('hasOverflow').promise().then(() => {
                let jumps   = 0,
                    lines   = 0,
                    offset  = 0;

                container.find('p.list-of-links > span.blb-link').each((i,el) => {
                    LayoutHelper.overflows( $(el), viewspace, false, {x:0,y:5} ) ? ++jumps : ++lines;

                    if( jumps == 1 ) {
                        if( !LayoutHelper.overlaps( $(el), viewspace, true, {x:0,y:-5} ) ) return;

                        let p1 = LayoutHelper._getElementRect($(el)),
                            p2 = LayoutHelper._getElementRect(viewspace);

                        offset = p1[1].y - p2[1].y;
                    }
                });

                container.data({
                    'viewspace':           lines,
                    'location':            0,
                    'location-max':        jumps,
                    'offset':              offset,
                });
            });
        });
    }
    */

    cutText(){
        var cutFunc = ( text, buffer ) => {
            if( typeof text === 'undefined' || text === "" ) return -1;
            // remove leading breaks, p closing tag and three dots
            text = text.slice(0, text.lastIndexOf("</p>")).replace(/\s*$/, "").replace(/\.\.\.$/, "");
            let i = -1;

            if( text.slice(-1) === ">" ){ //special handling for html tags
                if( text.slice(-3) === "<p>" ){ //handle multiple paragraphs
                    i = text.lastIndexOf("</p>");
                } else if( text.search(/<\/[^<]+>$/) === -1 ){ //shorthand tags
                    i = text.search(/\s*<[^<]*>$/);
                } else { //full tags
                    var tag = text.slice(text.search(/[^\/]*>$/), -1);
                    i = text.lastIndexOf("<"+tag);
                }
            } else { //normal handling
                i = text.search(/\s*[^\s>]+\s*$/);
            }
            if(i == -1) return -1;

            if(buffer) buffer.push(text.slice(i));
            return text.slice(0, i)+"...</p>";
        };
        var addFunc = ( text, buffer ) => {
            if(buffer.length == 1 && buffer[0].match(/<\/p>\s*<p>/gm)){
                buffer.length = 0;
                text = text.slice(0, -7);
            } else {
                text = text.slice(0, -7) + buffer.pop();
            }
            text += buffer.length > 0 ? '...</p>' : '</p>';
            return text;
        };

        // iterate over all quadratic boxes
        $('.blb-box-quadratic').each( (i, self) => {
            // Skip if we encounter a list-of-links
            if( $(self).find('.blb-textpic.lol').length > 0 ) return;

            if( !this.buffer[i] ) this.buffer[i] = [];
            if( i < 1 ){ // special handling for slider element
                let targetHeight = LayoutHelper.isCollapsedView() ? Number.MAX_SAFE_INTEGER : $(self).outerHeight() / 2;
                $(self).find('.blb-text').each( (j, self) => {
                    if( !this.buffer[i][j] ) this.buffer[i][j] = [];

                    let height = $(self).outerHeight();
                    //add
                    while( height < targetHeight && this.buffer[i][j].length ){
                        var tempText = $(self).html();
                        if( typeof tempText === 'undefined' || tempText === "" ) break;
                        $(self).html(addFunc(tempText, this.buffer[i][j]));
                        height = $(self).outerHeight();
                    }
                    //remove
                    while( height > targetHeight ){
                        var tempText = cutFunc($(self).html(), this.buffer[i][j]);
                        if( tempText === -1 ) break;
                        $(self).html(tempText);
                        height = $(self).outerHeight();
                    }
                });
            } else {
                let text = $(self).find('.blb-text').first();
                let pad_bot = text[0] ? parseInt(text.css('padding-bottom')) : 0;
                let targetHeight = pad_bot;
                if(LayoutHelper.isCollapsedView()){
                    targetHeight = Number.MAX_SAFE_INTEGER;
                } else if($(self).find('.half').length > 0){
                    targetHeight += $(self).outerHeight() / 2;
                } else {
                    targetHeight += $(self).outerHeight();
                }

                if( $(self).find('.blb-image').length ) targetHeight -= $(self).find('.blb-image').height();
                let height = $(text).outerHeight();
                //add
                while( height < targetHeight && this.buffer[i].length ){
                    var tempText = $(text).html();
                    if( typeof tempText === 'undefined' || tempText === "" ) break;
                    $(self).find('.blb-text').html(addFunc(tempText, this.buffer[i]));
                    height = $(text).outerHeight();
                }
                //remove
                var j = 0;
                while( height > targetHeight && j < 100 ){
                    var tempText = cutFunc($(text).html(), this.buffer[i]);
                    if( tempText === -1 ) break;
                    $(text).html(tempText);
                    height = $(text).outerHeight();
                    j++;
                }
            }
        });
    }

    resizeText(){
        var width = window.innerWidth;
        var boxes = $('.blb-box-quadratic .blb-text');

        if( width < App.getInstance()._breakpoints['xs'] ){
            $(boxes).css('font-size', '');
        } else if( width < App.getInstance()._breakpoints['lg'] ){
            $(boxes).css('font-size', '13.5px');
        } else if( width < 1330 ){
            $(boxes).css('font-size', '12.2px');
        } else if( width < 1380 ){
            $(boxes).css('font-size', '12.8px');
        } else if( width < 1430 ){
            $(boxes).css('font-size', '13.5px');
        } else if( width < 1480 ){
            $(boxes).css('font-size', '14.2px');
        } else if( width < 1530 ){
            $(boxes).css('font-size', '14.8px');
        } else if( width < 1580 ){
            $(boxes).css('font-size', '15.5px');
        } else {
            $(boxes).css('font-size', '16.2px');
        }
    }


    _onResize() {
        //this.resizeText();
        //this.cutText();
        //this.linkListToggle(); Old behaviour, just keeping this in case it's needed again -> See func doc for details
    }
}